<template>
  <div>
    <el-collapse v-model="activeNames" accordion>
      <el-collapse-item title="1.Who can be a ShopVidi customer?" name="1">
        <div class="collapse-content">
              a) Brick & mortar store <br>
              b) Online boutique <br>
              c) Shop in shops/Pop-up store
        </div>
      </el-collapse-item>
      <el-collapse-item title="2.How long does it take to receive the goods after placing an order?" name="2" class="item-low">
        <div class="collapse-content">
                 a) Shipping from local warehouse: 3-5 days (USA）<br>
                  b) Shipping from cross-border warehouse: 10-15 days (China）
        </div>
      </el-collapse-item>
      <el-collapse-item title="3.Limitations of order-placing policy?" name="3">
        <div class="collapse-content">
                    a) No MOQ limitation <br>
                    b) No brand limitation <br>
                    c) Free shipping on opening order
        </div>
      </el-collapse-item>
      <el-collapse-item title="4.How to finish the payment?" name="4">
        <div class="collapse-content">
          a) By credit card (Visa/MasterCard）<br>
          b) By approved net term credit  (Only for brick & mortar stores）<br>
            Currently, we only  offer brick-and-mortar store owners in the US the option to apply for a net 60 terms.<br>
            You need to submit the following information to the financial institution:<br>
            &nbsp;&nbsp;I. The repayment card<br>
           &nbsp;&nbsp;II. Store information, such as store photo, invoice and transaction records for the past 3 months, business registration information
        </div>
      </el-collapse-item>
      <el-collapse-item title="5.How does ShopVidi guarantee prices? " name="5">
        <div class="collapse-content">
             a) All brands come directly from the manufacturer to ensure the best price for you <br>
            b) If you do happen to find better pricing online for any of the products on ShopVidi, we'll match their offer. <br>
            c) Only verified wholesale clients can see the wholesale price
        </div>
      </el-collapse-item>
      <el-collapse-item title="6.  How does ShopVidi’s quality control work? " name="6">
        <div class="collapse-content">
              a) The samples by each brand will be reviewed carefully while on the shelf <br>
              b) Every order will be delivered only after QA processing at our warehouse <br>
              c) Every complaint related to quality will be highly valued by ShopVidi and refunded by the recognized order to the purchaser
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: '1'
    }
  }
}
</script>

<style lang="less" scoped>
.el-collapse-item{
  border-bottom:1px solid #262613 ;
}
/deep/.el-collapse-item__header{
  justify-content: left !important;
  background: none !important;
  border-bottom: 1px solid #262613 !important;
  font-size: 16px;
  font-family: Satoshi-Medium;
  height: auto !important;
}
.collapse-content{
  padding: 10px 0;
  font-size: 16px;
  font-family: Satoshi;
  font-weight: 400;
  line-height: 24px;
}
/deep/.el-collapse-item__content{
  background: rgba(225,226,191,0.3900);
}
/deep/.el-collapse-item__arrow{
  display: block !important;
}
/deep/.el-collapse-item__header{
  border-bottom:0 !important ;
}
@media screen and(max-width:750px) {
    .item-low{
      padding: 5px 0;
      /deep/.el-collapse-item__header{
        line-height: 24px !important;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/collapse.vue